import { createSelector } from 'reselect'

const getEvents = (state) => state.calendar.items.byId

export const getEventsById = createSelector([getEvents], (events) => events)

export const getEventsArray = createSelector([getEvents], (events) => Object.values(events))
